import store from '../../../store/configureStore';

export function getTranslation(key) {
    // grab current state
    const state = store.getState();
    if (state.olxstore.storeOpts.customTranslation) {
        if (state.olxstore.storeOpts.customTranslation[key]) {
            return state.olxstore.storeOpts.customTranslation[key];
        }
    }
    return state.i18n.language.key !== "us" ? state.i18n.phrases[key] : key;
}